import { Colors, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface AgendaOpeningStatementTitleProps {
    /** `large` where the statement is edited in place, under the larger title the design gives it.
     * @default 'default' */
    size?: 'default' | 'large';
}

/** The dot and the title in front of an opening statement, whichever way the statement is edited. */
export const AgendaOpeningStatementTitle = ({
    size = 'default',
}: AgendaOpeningStatementTitleProps) => {
    const { t } = useAmelioTranslations();

    return (
        <>
            <span
                aria-hidden
                className={'bg-primary-500 h-2 w-2 rounded-full'}
            />
            <Text
                size={size}
                weight={'semibold'}
                color={Colors.BASE_600}
            >
                {t('meetingAgenda.openingStatement')}
            </Text>
        </>
    );
};
